module.exports = __webpack_public_path__ + "assets/img/iFind数据库.c94f733b.png";